module.exports = __webpack_public_path__ + "img/caja-huancayo.483f0711.svg";